module.exports = __webpack_public_path__ + "static/media/Benchmarking.ea5e56dc.png";